<template>
  <div v-if="$store.state.selectCompany" class="teams-login">

    <div class="container">

        <div class="logo pt-4 pb-5">
            <img src="/static/img/ConvertLabs.svg" alt="Convertlabs Logo">  
            <div class="fw-500 text-center">Service Providers</div>  
        </div>

        <div class="mb-3">Hello <span class="fw-500">{{ $route.query.team_email }}</span>, please select a company below</div>

            <div 
            v-for="(team, index) in $store.state.selectCompany"
            :key="index"
            @click="loginFor(team.id)"
            class="card company"
            >
            <div class="d-flex align-items-center">
                <img height="50" width="50" :src="company_logo(team.company.company_logo)"/>
                <div class="d-flex flex-column ml-3">
                    <span class="capitalize text-truncate team-title fs-14 fw-500">{{ team.title }}</span>
                    <span class="capitalize text-truncate company-name fs-14 secondary-text">{{ team.company.company_name }}</span>     
                </div>
            </div>
            <el-button @click="loginFor(team.id)" class="primary-button" type="primary">Log In</el-button>
        </div>
    </div>
      
  </div>
</template>

<script>
export default {
  name: 'ChooseCompany',
  methods: {
    loginFor (teamId) {
      this.$post('api/teams' + this.$route.fullPath + '&team=' + teamId).then((response) => {
        if (response.ok) {
          response.json().then((result) => {
            if (result.team) {
              this.$store.commit('SET_TEAM', result)
              this.$store.commit('SET_LOGIN', true)
            }
          })
        } else {
          response.json().then((result) => {
            this.$store.commit('SET_LOGIN', false)
            this.$store.state.signinError = result.error
          })
        }
      })
    },

    company_logo (company_logo) {
      if (company_logo) { return 'https://convertlabs.io/' + company_logo.replace('public', 'storage') }
    }
  }
}
</script>

<style scoped>

    .teams-login {
        width: 100vw;
    }

    .teams-login .container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .logo img {
        max-width: 400px;
    }

    .company {
        max-width: 700px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        gap: 16px;
        margin-bottom: 16px;
    }


</style>



// WEBPACK FOOTER //
// src/views/auth/ChooseCompany.vue